<template>
    <div
        class="px-4"
    >

        <v-flex
            xs12
            v-if="benefits_requested"
        >
            <h3
                :class="[$vuetify.theme.dark ? 'white--text' : 'primary--text', isMobile ? '' : 'mb-3']"
                class="text-center text-uppercase"
            >
                You qualify for a<br> bond of {{ benefits.maximumEstimatedBond.value | currency_no_decimals }} <br> at
                {{ benefits.maximumMonthlyRepayment.value | currency }} pm over 20 years
            </h3>

        </v-flex>

        <div
            v-if="!mobile"
            class="text-center mb-3"
        >
            <img
                class="svg-icon-avatar"
                :src="svgPath"
                width="150"
                height="150"
            >
        </div>

        <v-layout
            wrap
            row
            v-if="!isMobile"
        >
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        x-large
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        {{ parseInt(client.gender) !== 1 ? '$mdiLegacyFemale' : '$mdiLegacyMale' }}
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        {{ parseInt(client.gender) !== 1 ? 'Female' : 'Male' }}
                    </h4>
                </div>
            </v-flex>
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        x-large
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        {{ parseInt(client.smoker) !== 1 ? '$mdiLegacySmoking' : '$mdiLegacySmokingOff'}}
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        {{ parseInt(client.smoker) !== 1 ? 'Smoker' : 'Non-smoker'}}
                    </h4>
                </div>
            </v-flex>
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        x-large
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        $mdiLegacyANB
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        ANB: {{ parseInt(client.age) + 1 }}
                    </h4>
                </div>
            </v-flex>
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        x-large
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        {{ '$mdiLegacyCat' + client_rating }}
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        Category
                    </h4>
                </div>
            </v-flex>

            <v-flex
                xs12
                v-if="!isMobile && client.bank !== 9"
                class="justify-center align-center"
            >
                <v-layout
                    wrap
                    row
                    class="justify-center"
                >
                    <v-flex
                        xs12
                        md10
                        lg8
                    >
                        <img
                            :src="'/static/banks/' + client.bank + '.jpg'"
                            class="img-fluid"
                        >
                    </v-flex>
                </v-layout>
            </v-flex>

        </v-layout>
    </div>
</template>

<script>
    import HomeVantageMixin from "../../homevantage";

    export default {
        name: 'HomeVantage-Summary-Icons',

        mixins: [
            HomeVantageMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            svgPath() {
                let url = parseInt(this.client.gender) !== 1 ? 'female' : 'male';

                if (this.client.age <= 33) {
                    url += '-young';
                }

                if (this.client.age >= 48) {
                    url += '-old';
                }

                return '/static/calculators/' + url + '.svg';
            }
        },

        data() {
            return {}
        },

        methods: {}
    }
</script>
